import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-评分",
  "use": "icon-评分-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-评分\"><defs><style type=\"text/css\"></style></defs><path d=\"M519.168 70.144 615.7824 265.8048 831.6928 297.1904 675.4304 449.5104 712.3456 664.576 519.168 563.072 326.0928 664.576 362.9056 449.5104 206.6688 297.1904 422.6304 265.8048Z\" p-id=\"7019\" /><path d=\"M244.1216 580.0448 298.8544 690.9696 421.2736 708.7616 332.6976 795.1104 353.6128 916.992 244.1216 859.4432 134.6304 916.992 155.5456 795.1104 66.9696 708.7616 189.3888 690.9696Z\" p-id=\"7020\" /><path d=\"M779.8784 580.0448 834.6368 690.9696 957.0304 708.7616 868.4544 795.1104 889.3184 916.992 779.8784 859.4432 670.4128 916.992 691.3024 795.1104 602.7264 708.7616 725.12 690.9696Z\" p-id=\"7021\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/评分.svg
// module id = Y6bU
// module chunks = 54